<template>
  <div class="parameterLine">
    <div class="content-container">
      <div class="titieMian">
        <div class="title-container">参数曲线</div>
        <div class="select-container">
          <div class="select-container-box">
            <span>基地&nbsp;&nbsp;</span>
            <el-select v-model="fishBaseIds" filterable placeholder="请选择基地"  size="small" @change="baseChange" >
              <el-option
                v-for="(item, index) in baseList"
                :key="index"
                :label="item.value"
                :value="item.key">
              </el-option>
            </el-select>
          </div>
          <div class="select-container-box" >
            <span>塘口&nbsp;&nbsp;</span>
            <el-select v-model="pondId" filterable placeholder="请选择塘口"  size="small" >
              <el-option
                v-for="(item, index) in pondList"
                :key="index"
                :label="item.value"
                :value="item.key">
              </el-option>
            </el-select>
          </div>
          <div class="select-container-box">
            <span>时间&nbsp;&nbsp;</span>
            <el-date-picker
              size="small"
              v-model="start"
              type="date"
              :clearable="false"
              placeholder="开始日期"
              @change="changeTime(0)"
              value-format="yyyy-MM-dd"
              :picker-options="pickerTimeOptions">
            </el-date-picker>
          </div>
          <div class="select-container-box" style="padding:0 5px">
            <span>至</span>
          </div>
          <div class="select-container-box" style="padding:0 1px">
            <el-date-picker
              size="small"
              v-model="end"
              type="date"
              :clearable="false"
              placeholder="结束日期"
              value-format="yyyy-MM-dd"
              @change="changeTime(1)"
              :picker-options="pickerTimeOptions">
            </el-date-picker>
          </div>
          <div class="select-container-box"  v-if="canEditAll=true">
            <el-button size="small" type="info" plain @click="goSearch()" class="query" >查询</el-button>
          </div>
        </div>
      </div>
      <!-- 曲线 -->
      
      <div class="table-container">
        <div style="display:flex;justify-content:flex-end">
          <el-radio-group v-model="parameterItemId" size="small" @change="goSearch()">
            <el-radio-button  
             v-for="(item, index) in typeList"
                :key="index"
                :label="item.id"
                :value="item.id">
                {{item.name}}
            </el-radio-button>
          </el-radio-group>
        </div>
        <div ref="histogram"  class="histogram" style="height:560px;"></div>
      </div>
      <div v-if="noData" class="noLineData">
        <span>暂无数据</span>
        <img src="../../../../../public/img/nodata.png" alt="" >
      </div>
    </div>
  </div>
</template>


<script>
import { mapActions, mapState } from "vuex";
import echarts from "echarts";
import { modules } from "../../../../store";
import { storage } from "../../../../service/storage";
import { MessageBox, Message } from "element-ui";
import checkPermission from "../../../../service/checkPermission.js";
import {
  resolveFishBaseKeyFromList,
  fishBaseIdForQuery,
} from "@/common/resolveFishBaseSelection.js";
export default {
  name: "parameterLine",
  data() {
    return {
      noData: false,
      fishBaseIds: "", //基地
      baseList: [], //基地列表
      pondList: [], //塘口列表
      typeList: [],
      pondId: "", //塘口
      start: "", //开始时间
      end: "", //结束时间
      pickerTimeOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now() - 8.64e6;
        }
      },
      parameterItemId: "",
      list: [],
      xdata: [],
      seriesData: []
    };
  },
  async mounted() {
    this.baseList = await this.getAllBaseList(); //基地信息
    this.fishBaseIds = resolveFishBaseKeyFromList(
      this.baseList,
      storage.get("base")
    );
    if (this.fishBaseIds != null && this.fishBaseIds !== "") {
      this.pondList = await this.getFishPond(this.fishBaseIds);
      if (this.pondList.length > 0) {
        this.pondId = this.pondList[0].key;
      }
    } else if (!this.baseList || !this.baseList.length) {
      this.pondId = -1;
    }

    this.typeList = await this.getParamsType(); //获取水质参数列表
    this.parameterItemId = this.typeList[0].id;
    this.histogram(); //报表
    this.goSearch();
  },
  //默认时间
  created() {
    let startTime = storage.get("start");
    let endTime = storage.get("end");
    if (startTime) {
      this.start = startTime;
    } else {
      const start = new Date();
      start.setDate(1);
      this.start = this.$timeformatDay(start);
    }
    if (endTime) {
      this.end = endTime;
    } else {
      this.end = this.$timeformatDay(new Date());
    }
  },
  methods: {
    ...mapActions(modules.waterQualityParameter, {
      getLineData: "getLineData" //获取参数曲线数据
    }),
    ...mapActions(modules.base, [
      "getAllBaseList" //基地信息
    ]),
    ...mapActions(modules.pond, {
      getFishPond: "getFishPond" //塘口
    }),
    ...mapActions(modules.dataDict, {
      getParamsType: "getParamsType" //获取水质参数种类
    }),
    //改变基地数据
    baseChange(e) {
      storage.set("base", e);
      this.pondList = [];
      if (!e) return;
      this.getFishPond(e)
        .then(data => {
          this.pondList = data;
          if (this.pondList.length > 0) {
            this.pondId = this.pondList[0].key;
          }
          if (this.pondList.length === 0) {
            this.$Alert.info({
              content: "当前选择的基地下面无塘口，请先添加",
              duration: 5000,
              status: "error"
            });
            this.pondId = null;
          }
        })
        .catch(() => {});
    },
    //存储选中时间
    changeTime(type) {
      if (type == 0) {
        storage.set("start", this.start);
      } else {
        storage.set("end", this.end);
      }
    },
    //参数曲线
    histogram() {
      let myChart = this.$echarts.init(this.$refs.histogram);
      myChart.showLoading({
        text: "数据获取中",
        effect: "whirling"
      });
      setTimeout(function() {
        myChart.hideLoading();
      }, 500);
      myChart.setOption({
        title: {
          text:
            this.typeList.find(f => f.id == this.parameterItemId).name +
            "变化曲线图",
          // left: "45%",
          top: "1%"
        },
        tooltip: {
          trigger: "axis"
        },
        grid: {
          bottom: "14%",
          left: "5%",
          right: "5%"
        },
        xAxis: {
          type: "category",
          boundaryGap: false,
          data: this.xdata,
          axisLabel: {
            color: "#999999"
          },
          axisLine: {
            show: true,
            lineStyle: {
              color: "#d3d3d3"
            }
          }
        },
        yAxis: {
          type: "value",
          splitLine: { show: false },
          axisLabel: {
            formatter: "{value} ",
            color: "#999999"
          },
          axisLine: {
            show: true,
            lineStyle: {
              color: "#d3d3d3"
            }
          }
        },
        dataZoom: {
          show: true
        },
        series: [
          {
            name: this.typeList.find(f => f.id == this.parameterItemId).name,
            type: "line",
            smooth: true,
            data: this.seriesData,
            areaStyle: {
              normal: {
                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  {
                    offset: 1,
                    color: "rgba(71,241,255,0.1)"
                  },
                  {
                    offset: 0,
                    color: "rgba(0,99,255,0.1)"
                  }
                ])
              }
            },
            color: new echarts.graphic.LinearGradient(0, 0, 1, 1, [
              // {
              //   offset: 1,
              //   color: "rgb(71,241,255)"
              // },
              {
                offset: 0,
                color: "rgb(0,99,255)"
              }
            ]) //线条渐变色
          }
        ]
      });
      window.addEventListener("resize", function() {
        myChart.resize();
      });
    },
    //查询所有数据
    async goSearch() {
      let obj = {
        startDate: this.start,
        endDate: this.end,
        fishBaseId: fishBaseIdForQuery(this.fishBaseIds, this.baseList),
        parameterItemId: this.parameterItemId,
        pondId: this.pondId != "" ? this.pondId : -1
      };
      await this.getLineData(obj)
        .then(rsp => {
          if (rsp.status === 200) {
            if (rsp.data.total === 0) {
              this.xdata = [];
              this.seriesData = [];
              this.histogram();
              this.noData = true;
              return;
            } else {
              this.xdata = rsp.data.list
                .filter(item => item.value !== null)
                .map(item => this.$timeformat(item.dateTime));
              this.seriesData = rsp.data.list
                .filter(item => item.value !== null)
                .map(item => item.value);
              this.noData = false;
              this.histogram();
            }
          }
        })
        .catch(err => {
          this.$Alert.info({
            content: err.response.data.list,
            duration: 5000,
            status: "error"
          });
          // this.$message.error(err.response.data.list);
          // console.dir(err);
        });
    },

    // 格式化指定列时间
    formatter(row) {
      if (!row.date) {
        return false;
      }
      return this.$timeformatDay(row.date);
    },

    resetForm(formName) {
      this.$refs[formName].resetFields();
    }
  },
  computed: {}
};
</script>
<style lang="stylus" >
  .noLineData
    span
      position:absolute;
      top:60%;
      left:51.5%;
      color:#666;
      font-size:20px;
    img 
      position:absolute;
      top:45%;
      left:50%;

.el-radio-group
  margin-right:86px;
</style>
